export default __webpack_public_path__ + "static/media/invest_transfer_icon.196ba2d1.svg";